<vdr-card title="Pricing" style="margin-bottom: calc(var(--space-unit) * 2)">
  <form class="form-grid" [formGroup]="detailForm">
    <ng-container formGroupName="customFields">
      <vdr-form-field label="Cost Price">
        <vdr-currency-input
          [currencyCode]="currencyCode$ | async"
          formControlName="costPrice"
        />
      </vdr-form-field>
    </ng-container>
  </form>
</vdr-card>
